var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    d: "M74.7685 51.8923L62.3349 62.4089L49.9012 72.9255C44.2118 65.9153 45.1663 55.524 52.0332 49.7158C58.9002 43.9076 69.0791 44.8821 74.7685 51.8923Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 13",
    d: "M5.83892 51.8923L18.2725 62.4089L30.7062 72.9255C36.3956 65.9153 35.4411 55.524 28.5742 49.7158C21.7073 43.9076 11.5283 44.8821 5.83892 51.8923Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10",
    d: "M74.7685 26.6135L62.3349 16.0969L49.9012 5.58031C44.2118 12.5905 45.1663 22.9819 52.0332 28.7901C58.9002 34.5982 69.0791 33.6238 74.7685 26.6135Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 14",
    d: "M5.83891 26.6135L18.2725 16.0969L30.7062 5.58031C36.3956 12.5905 35.4411 22.9819 28.5742 28.7901C21.7073 34.5982 11.5283 33.6238 5.83891 26.6135Z",
    fill: "#60C2A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M55.7467 73.975L39.5999 73.975L23.4531 73.975C23.4531 64.8712 30.6823 57.4912 39.5999 57.4912C48.5175 57.4912 55.7467 64.8712 55.7467 73.975Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 11",
    d: "M55.7467 4.71741L39.5999 4.7174L23.4531 4.7174C23.4531 13.8211 30.6823 21.2012 39.5999 21.2012C48.5175 21.2012 55.7467 13.8211 55.7467 4.71741Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M74.7132 23.1438L74.7132 39.6276L74.7132 56.1113C65.7956 56.1113 58.5664 48.7313 58.5664 39.6276C58.5664 30.5238 65.7956 23.1438 74.7132 23.1438Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 12",
    d: "M5.40399 23.1438L5.40399 39.6276L5.40399 56.1113C14.3216 56.1113 21.5508 48.7313 21.5508 39.6276C21.5508 30.5238 14.3216 23.1438 5.40399 23.1438Z",
    fill: "#284993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSupport);
export default __webpack_public_path__ + "static/media/GroupSupport.14ec7bff05d1660edcacb2386e5a4cb2.svg";
export { ForwardRef as ReactComponent };